const HowDoIt = () => {
    return(
        <>
        <div className="blockHowDoIt">
            <div className="blockHowDoItInfo">
                <p className="blockHowDoItInfoP">How we do it</p>
                <h3 className="blockHowDoItInfoH3">Violet is the first to standardize cultural competence.</h3>
                <p className="blockHowDoItInfoP2">By translating decades worth of research, we’ve identified the
                   core elements of cultural competence. This clinically-measured 
                   framework allows us to objectively benchmark providers across the industry.</p>
                <p className="blockHowDoItInfoP3">Now, we can better understand as an industry how we’re doing and provide a baseline for education and improvement.</p>
            </div>
            <div className="blockHowDoItImg">
                <img src=".\img\men2.png" alt="" />
            </div>
        </div>
      <div className="vectorHowDoIt">
        <svg width="550" height="11" viewBox="0 0 550 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.828125" width="550" height="10" fill="#B961CD"/>
        </svg>
      </div>
        <div className="vector2HowDoIt">
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15Z" stroke="#134A45"/>
            </svg>

        </div>
        </>
    );
}

export default HowDoIt;